import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { TranslateModule } from '@ngx-translate/core';
import {
  CachePreventionInterceptor,
  CoreModule as EuiCoreModule,
  CorsSecurityInterceptor,
  CsrfPreventionInterceptor,
  EUI_CONFIG_TOKEN,
  EuLoginSessionTimeoutHandlingInterceptor,
  provideEuiInitializer,
  translateConfig,
} from '@eui/core';

import { routes } from './app.routes';
import { AppStarterService } from './app-starter.service';
import { CustomErrorHandler } from './shared/services/custom-error-handler';
import { appConfig as euiAppConfig } from '../config/index';
import { environment } from '../environments/environment';

const init = () => {
  const appStarter = inject(AppStarterService);
  return appStarter.start();
};

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: EUI_CONFIG_TOKEN,
      useValue: { appConfig: euiAppConfig, environment },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CorsSecurityInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EuLoginSessionTimeoutHandlingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CsrfPreventionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CachePreventionInterceptor,
      multi: true,
    },
    provideEuiInitializer(),
    AppStarterService,
    provideAppInitializer(init),
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      EuiCoreModule.forRoot(),
      TranslateModule.forRoot(translateConfig),
    ),
    provideRouter(routes),
    provideAnimations(),
    provideMomentDateAdapter(),
  ],
};
